var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")}}),_c('h1',[_vm._v(_vm._s(_vm.$t('payment_complete')))]),_c('h3',[_vm._v(_vm._s(_vm.error))]),_c('button',{on:{"click":_vm.backToApp}},[_vm._v(_vm._s(_vm.$t('back_to_app')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }